import { gql } from '@apollo/client';

const PATIENT_FRAGMENT = gql`
  fragment PatientFragment on Patient {
    contact {
      address
      city
      state
      country
      zip
      phone1
      phone2
    }
    secondaryContact {
      name
      phone
      relationship
      email
    }
    patientId
    dob
    firstName
    middleName
    lastName
    gender
    email
    weight
    height
    isMetric
    ethnicity
  }
`;

export default PATIENT_FRAGMENT;
